import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b1b6124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-analysis-contract home-view-box" }
const _hoisted_2 = { class: "home-analysis-contract-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DetailTitle, { title: "合同信息查询" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        ref: "form",
        model: _ctx.data,
        name: "horizontal_login",
        layout: "inline",
        autocomplete: "off",
        onFinish: _ctx.onFinish
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "合同编号",
            name: "contractNumber",
            rules: [{ required: true, message: '请输入合同编号!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                style: {"width":"200px"},
                "show-search": "",
                value: _ctx.data.contractNumber,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.contractNumber) = $event)),
                "filter-option": false,
                options: _ctx.contractNumber.list,
                onSearch: _ctx.onSearch,
                placeholder: "请输入合同编号"
              }, null, 8, ["value", "options", "onSearch"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "default",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("跳转至合同信息查询")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish"])
    ])
  ]))
}